













































































































import { Getter } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import getUrlParam from "@/common/utils/getUrlParam";
import getActivityDeadline from "@/common/utils/getActivityDeadline";
import { replaceMultiLineString } from "@/common/utils/dealWithString";
import getActivityType from '@/common/utils/getActivityType';
import { Ladder } from "@/common/interface/group_type";

@Component
export default class GroupTitleSection extends Vue {
  @Getter("title") getterTitle!: string;
  @Getter("section") section!: any;
  @Getter('urlUid') urlUid!: string;
  @Getter("gradientColor") gradientColor!: string;
  @Getter("mainTextColor") mainTextColor!: string;
  @Getter("deadline") deadline!: number;
  @Getter("startTime") startTime!: number;
  @Getter("groupCreateNumber") groupCreateNumber!: number;
  @Getter("groupCompleteNumber") groupCompleteNumber!: number;
  @Getter("groupFullNumber") groupFullNumber!: number;
  @Getter("showJoinFooter") showJoinFooter!: boolean;
  @Getter("canPay") canPay!: boolean;
  @Getter("payType") payType!: string;
  @Getter("courseType") courseType!: string;
  @Getter("cancel") cancel!: boolean;
  @Getter("hasPay") hasPay!: number;
  @Getter("nickname") nickname!: string;
  @Getter("avatar") avatar!: string;
  @Getter("uid") uid!: string;
  @Getter("payNumber") payNumber!: number;
  @Getter("version") version!: string;
  @Getter("ladderGroupList") ladderGroupList!: Array<Ladder>;
  @Getter("showNum") showNum!: boolean;
  @Getter('courseGroupList') courseGroupList!: any;

  type: string = getUrlParam("type") as string;
  originPrice: number = 0;
  activityStatus: string = "noStart";
  templateType: string = getActivityType() as string;

  
  get title(): string {
    return replaceMultiLineString(this.getterTitle);
  }
  get isActivityFinish(): boolean {
    const { nowTimestamp, activityDeadline } = this.dealwithTime(this.deadline);
    return nowTimestamp >= activityDeadline;
  }

  // 剩余天数
  get deadlineDay(): number {
    return getActivityDeadline(this.deadline).deadlineDay;
  }
  // 剩余小时
  get deadlineHour(): string | number {
    return getActivityDeadline(this.deadline).deadlineHour;
  }
  // 剩余分钟
  get deadlineMinute(): string | number {
    return getActivityDeadline(this.deadline).deadlineMinute;
  }

  get isActivityStart(): boolean {
    return new Date().valueOf() < this.startTime;
  }

  // 剩余天数
  get startTimeDay(): number {
    return getActivityDeadline(this.startTime).deadlineDay;
  }
  // 剩余小时
  get startTimeHour(): string | number {
    return getActivityDeadline(this.startTime).deadlineHour;
  }
  // 剩余分钟
  get startTimeMinute(): string | number {
    return getActivityDeadline(this.startTime).deadlineMinute;
  }
  get maxFirstReward() {
    let max = 0;
    this.courseGroupList.map((item:any) => {
      if (Number(item.firstReward) > max) {
        max = item.firstReward;
      }
    })
    return max;
  }
  mounted() {
    setTimeout(() => {
      this.getActivityStatus();
    }, 50);

  }
  dealwithTime(activityDeadline: any) {
    const nowTimestamp: number = new Date().valueOf();
    return {
      nowTimestamp,
      activityDeadline
    };
  }
  getActivityStatus(){
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if(activityStartTime > nowTimestamp){
      // this.cutdownBackground = "https://image.xiaomaiketang.com/xm/xwwkEzBXJZ.png";
      // this.cutdownTextColor= "#FF812A";
      // this.cutdownTimeColor = "#FF812A";
      this.activityStatus = "noStart"
    }else{
      if(nowTimestamp<activityDeadline){
        // this.cutdownBackground = "https://image.xiaomaiketang.com/xm/2KeEMyCkTa.png";
        // this.cutdownTextColor= "#FF393B";
        // this.cutdownTimeColor = "#FF393A";
        this.activityStatus = "startIng";
      }else{
        // this.cutdownBackground = "https://image.xiaomaiketang.com/xm/57Dd6dyjhs.png";
        // this.cutdownTextColor= "#676E78";
        // this.cutdownTimeColor = "#999";
        this.activityStatus = "endIng";
      }
    }
  }
  // get integer() {
  //   const currentPriceStr = this.getCurrentPriceStr();
  //   return Number(currentPriceStr[0]);
  // }
  // get decimal() {
  //   const currentPriceStr = this.getCurrentPriceStr();
  //   return Number(currentPriceStr[1]);
  // }

  get groupPrice() {
    let min = this.courseGroupList[0].ladderGroupList[this.courseGroupList[0].ladderGroupList.length - 1].groupPrice;
    this.originPrice = this.courseGroupList[0].originPrice;
    for (let i = 0; i < this.courseGroupList.length; i++){
      const currentPrice = this.courseGroupList[i].ladderGroupList[this.courseGroupList[i].ladderGroupList.length - 1].groupPrice;
      if (Number(min) > Number(currentPrice)) {
        min = currentPrice;
        this.originPrice=this.courseGroupList[i].originPrice
      }
    }
    return min
  }

  get groupFullVisible() {
    for (let i = 0; i < this.courseGroupList.length; i++){
      if (this.courseGroupList[i].ladderGroupList.length > 1) {
        return true
      }
    }
    return false
  }
  // 获取拼团价的整数和小数
  getCurrentPriceStr(price:number,k: number = 0) {
    const currentPriceStr = price.toString().split(".");
    if (currentPriceStr[k]==='00') {
      return ''
    }
    return currentPriceStr[k];
  }
  toInvite() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
    } else {
      if (this.nickname) {
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        const scene = `activityId=${broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${this.avatar}&distributorId=${distributorId ? `${distributorId}` : `-1`}&parentUid=${this.urlUid}`;
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.navigateTo({
            url: `/pages/poster/index?${scene}`
          });
        }
      }
    }
  }
}
